import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Accordion, Badge} from "react-bootstrap";
import moment from "moment";
import {openPrescriptionSettings} from "../../../../_helpers/tabOpeners";

const PrescriptionSidebar = () => {
    const dispatch = useDispatch();
    const activeVisit = useSelector((state) => state.PRESCRIPTION.activeVisit);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const companyHasPrescription = useSelector((state) => state.PRESCRIPTION.companyHasPrescription);
    const details = companyDetails?.prescriptionDoctorDetails;
    const [accordionOpen, setSTAccordionOpen] = useState(false);
    const [tsKey, setTSKey] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTSKey(new Date().getTime());
        }, 900);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        getSelectedUnion();
    }, [companyDetails]);

    const getSelectedUnion = () => {
        if (companyDetails?.prescriptionSelectedUnitId) {
            const findMatch = companyDetails.prescriptionDoctorDetails?.doctorUnits?.find((el) => el.id === companyDetails?.prescriptionSelectedUnitId);
            if (findMatch) {
                return setSelectedUnit(findMatch);
            }
        }
        setSelectedUnit(null);
    }

    const handleOpenSettings = () => {
        dispatch(openPrescriptionSettings(TABS_DATA));
    }

    const containerStyle = {
        position: "relative",
        overflow: "hidden",
        borderRadius: "8px",
        border: "1px solid lightgray",
        overflowY: "auto",
        backgroundColor: "#fff"
    }

    const isInPrescriptionSettings = TABS_DATA[ACTIVE_MAIN_TAB]?.tabType === "prescription-settings";

    const toMinutesSeconds = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds - 60*minutes;
        if (minutes >= 0 && seconds >= 0) {
            return <>{minutes > 0 ? `${minutes} ${minutes === 1 ? "λεπτό" : "λεπτά"} και ` : ""}{seconds === 1 ? "1 δευτερόλεπτο" : ` ${seconds} δευτερόλεπτα`}</>
        } else {
            return <>0 δευτερόλεπτα</>
        }
    }

    return (
        <React.Fragment>
            {(companyHasPrescription && details) && (
                <div style={{width: "100%", padding: "5px", position: "absolute", bottom: "20px", zIndex: "100"}} className={"mt-1"}>
                    {activeVisit?.created_at && (
                        <div key={tsKey} style={{borderRadius: "8px", border: "1px solid lightgray", backgroundColor: "#fff", padding: "5px", textAlign: "center"}} className={"mb-1"}>
                            Έχετε ενεργή επίσκεψη εδώ και:<br/>
                            <strong>{toMinutesSeconds(moment().diff(activeVisit.created_at, "seconds"))}</strong>
                        </div>
                    )}
                    <div style={containerStyle} onMouseEnter={() => setSTAccordionOpen(true)} onMouseLeave={() => setSTAccordionOpen(false)}>
                        <Accordion activeKey={accordionOpen === true ? "0" : ""} className={"custom-accordion custom-accordion-prescription"}>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header onClick={() => setSTAccordionOpen(!accordionOpen)}><div style={{textAlign: "center"}}><u>Στοιχεία ιατρού</u></div></Accordion.Header>
                                <Accordion.Body style={{padding: '5px'}}>
                                    <div style={{fontSize: "14px"}}>
                                        <div className="d-flex justify-content-between">
                                            <span><strong>Ον/μο:</strong> {details.lastName} {details.firstName}<br/></span>
                                            {(!isInPrescriptionSettings && accordionOpen) && (
                                                <Badge style={{padding: "2px", maxHeight: "20px"}} bg={"primary"}>
                                                    <img
                                                        src={"assets/images/side-menu/Settings-white.png"}
                                                        alt={"Ρυθμίσεις"}
                                                        title={"Ρυθμίσεις Συνταγογράφησης"}
                                                        style={{width: "16px", height: "16px", cursor: "pointer"}}
                                                        onClick={() => handleOpenSettings()}
                                                    />
                                                </Badge>
                                            )}
                                        </div>
                                        <strong>ΑΜΚΑ:</strong> {details.amka}<br/>
                                        <strong>Ημ/νια Γέννησης:</strong> {moment(details.birthDate, "YYYY-MM-DD").isValid() ? moment(details.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY") : details.birthDate}<br/>
                                        <strong>Ειδικότητα:</strong> {details.doctorSpecialtyName}<br/>
                                        <strong>e-mail:</strong> {details.email}<br/>
                                        <strong>ΕΤΑΑ:</strong> {details.etaaRegNo}<br/>
                                        <strong>Τηλ.:</strong> {details.mobile}<br/>
                                        <strong>Αρ. Αδείας:</strong> {details.licenceNo}<br/>
                                    </div>
                                    {selectedUnit && (
                                        <React.Fragment>
                                            <div style={{textAlign: "center"}} className={"mt-1"}>
                                                <u>Μονάδα Συντ/σης</u>
                                            </div>
                                            <div style={{fontSize: "14px", textAlign: "center"}}>
                                                {selectedUnit.healthCareUnitDescription} ({selectedUnit.description})
                                            </div>
                                        </React.Fragment>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            )}
        </React.Fragment>
    )
}

export default PrescriptionSidebar;
